import { render, staticRenderFns } from "./TermsOfUseView.vue?vue&type=template&id=516362af&scoped=true"
import script from "./TermsOfUseView.vue?vue&type=script&lang=js"
export * from "./TermsOfUseView.vue?vue&type=script&lang=js"
import style0 from "./TermsOfUseView.vue?vue&type=style&index=0&id=516362af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516362af",
  null
  
)

export default component.exports